const displayAbonner = () => {
  let checkboxc = document.querySelectorAll('.selling-plan')
  checkboxc.forEach((item) =>{
    let acheteInput = item.querySelector('label.radio-buttons[title~="Acheter"] input')
    let selectorAboner = item.querySelector('div.select-wrapper')
    if(acheteInput.checked == true){
      console.log(acheteInput.checked);
      selectorAboner.style.display = 'none';
    }

    item.onclick = ()=>{
      if(acheteInput.checked == true){
        selectorAboner.style.display = 'none';
      }else{
        selectorAboner.style.display = 'block';
      }
    }
  });
}
export { displayAbonner }
